(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mnd-journey-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'mnd-journey-v1';
  const ttl = 4 * 60 * 60 * 1000;
  function safePath(raw, kind) {
    try {
      const url = new URL(raw, location.origin);
      const prefix = '(?:/[a-z]{2}(?:-[a-z]{2})?)?';
      const pattern = kind === 'collection'
        ? new RegExp('^' + prefix + '/collections/(?!all/?$)[a-z0-9-]+/?$','i')
        : new RegExp('^' + prefix + '(?:/collections/[a-z0-9-]+)?/products/[a-z0-9-]+/?$','i');
      return url.origin === location.origin && !url.username && !url.password && pattern.test(url.pathname) ? url.pathname : null;
    } catch { return null; }
  }
  function read() {
    try {
      const value = JSON.parse(sessionStorage.getItem(key));
      return value && typeof value === 'object' ? value : {};
    } catch { return {}; }
  }
  const memory = read();
  for (const kind of ['collection','product']) {
    const path = safePath(location.href, kind);
    if (path) memory[kind] = { path, time: Date.now() };
  }
  try { sessionStorage.setItem(key, JSON.stringify(memory)); } catch {}
  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('a[data-mnd-continue]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const candidates = ['collection','product'].map(kind => {
      const item = memory[kind];
      return item && Number.isFinite(item.time) && Date.now() >= item.time && Date.now()-item.time < ttl ? safePath(item.path,kind) : null;
    }).filter(Boolean);
    if (!candidates.length) return;
    event.preventDefault();
    if (link.dataset.mndBusy) return;
    link.dataset.mndBusy = 'true';
    for (const path of candidates) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1500);
      try {
        const result = await fetch(path, { method:'HEAD', signal:controller.signal, credentials:'same-origin', redirect:'error' });
        if (result.ok) { delete link.dataset.mndBusy; location.assign(path); return; }
      } catch {} finally { clearTimeout(timer); }
    }
    delete link.dataset.mndBusy;
    location.assign(link.href);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnd-journey-overlays"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!('IntersectionObserver' in window)) return;
  const selector = '.product-form__buttons, .cart__ctas';
  const observed = new Set();
  const visible = new Set();
  const update = () => document.body.classList.toggle('mnd-purchase-visible', visible.size > 0);
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.boundingClientRect.width && entry.boundingClientRect.height) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    update();
  }, { rootMargin: '24px 0px', threshold: 0 });
  const refresh = () => {
    for (const node of observed) {
      if (!node.isConnected) {
        observer.unobserve(node);
        observed.delete(node);
        visible.delete(node);
      }
    }
    document.querySelectorAll(selector).forEach(node => {
      if (!observed.has(node)) { observed.add(node); observer.observe(node); }
    });
    update();
  };
  refresh();
  new MutationObserver(refresh).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
